import { apiClient } from "@/helpers/ApiClient";
import { handleApiError } from "@/views/academy/api/handleApiError";

export const getRequest = (endpoint: any, config?: any) => {
  return apiClient
    .get(endpoint, config)
    .then((res: { status: number; data: unknown }) => {
      if (res.status === 200) {
        return res.data;
      } else {
        throw handleApiError(res);
      }
    })
    .catch(err => handleApiError(err));
};

export const getRawRequest = (endpoint: any, config?: any) => {
  return apiClient
    .get(endpoint, config)
    .then((res: { status: number; data: unknown }) => {
      if (res.status === 200) {
        return res;
      } else {
        throw handleApiError(res);
      }
    })
    .catch(err => handleApiError(err));
};

export const postRequest = (endpoint: any, body?: any, config?: any) => {
  return apiClient
    .post(endpoint, body, config)
    .then((res: { status: number; data: unknown }) => {
      if (res.status === 200) {
        return res?.data;
      } else {
        throw handleApiError(res);
      }
    })
    .catch(err => {
      handleApiError(err);
      return err;
    });
};

export const putRequest = (endpoint: any, body?: object, config?: any) => {
  return apiClient
    .put(endpoint, body, config)
    .then((res: { status: number; data: unknown }) => {
      if (res.status === 200) {
        return res?.data;
      } else {
        throw handleApiError(res);
      }
    })
    .catch(err => handleApiError(err));
};

export const patchRequest = (endpoint: any, body: object, config?: any) => {
  return apiClient
    .patch(endpoint, body, config)
    .then((res: { status: number; data: unknown }) => {
      if (res.status === 200) {
        return res?.data;
      } else {
        throw handleApiError(res);
      }
    })
    .catch(err => handleApiError(err));
};

export const deleteRequest = (endpoint: any, body?: object) => {
  return apiClient
    .delete(endpoint, body)
    .then((res: { status: number; data: unknown }) => {
      if (res.status === 200) {
        return res?.data;
      } else {
        throw handleApiError(res);
      }
    })
    .catch(err => handleApiError(err));
};
